import { cacheService } from "../../../Core/Api/services";
import { useAppSelector } from "../../../Redux/redux-store";
import {
  GetFilterText,
  GetLayout,
  GetLoadingStates,
  GetSearchResults,
} from "../../../Redux/Reducers/redux-slice-drive";
import { Box, CircularProgress } from "@mui/material";
import { PlatformMode } from "../../../Core/Api/Types/platform-mode";
import { DriveAssetGrid } from "../Common/drive-asset-grid";
import { CloudUploadOutlined } from "@mui/icons-material";
import EmptyListSlot from "../../Misc/EmptyListSlot";
import { useTranslation } from "react-i18next";
import { DriveAssetTable } from "../Common/drive-asset-table";
import { useSearchPagination } from "../helpers/use-drive-pagination";

export const DriveSearchContent = () => {
  // Local props & states
  const { t } = useTranslation();

  // Redux
  const { folderLoading } = useAppSelector(GetLoadingStates);
  const filterText = useAppSelector(GetFilterText);
  const searchResults = useAppSelector(GetSearchResults);
  const layout = useAppSelector(GetLayout);
  const { loadSearchContent } = useSearchPagination();

  // Cache
  const platformMode = cacheService.GetPlatformMode();

  // Local consts & functions
  const filteredRows = [...searchResults].filter((x) => filterText === "" || x.name?.includesAllWords(filterText));

  return (
    <>
      {folderLoading || (!searchResults && platformMode !== PlatformMode.Adam) ? (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "48%",
            left: "45%",
          }}
          size={48}
        />
      ) : (
        <Box
          sx={(theme) => ({
            height: "calc(100% - 120px)",
            width: "100%",
          })}
        >
          {filteredRows.length === 0 ? (
            <EmptyListSlot
              title={t("component:emptyListSlot.title.noSearchResults")}
              desc={t("component:emptyListSlot.desc.noSearchResults")}
              icon={<CloudUploadOutlined />}
              sx={{ background: "transparent", position: "relative", top: "calc(50% - 150px)" }}
              width="100%"
            />
          ) : (
            <>
              {layout === "grid" && <DriveAssetGrid resultObjects={searchResults} loadContents={loadSearchContent} />}
              {layout === "list" && (
                <Box px={2} width="100%" height="100%">
                  <DriveAssetTable resultObjects={searchResults} loadContents={loadSearchContent} />
                </Box>
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
};
